import script from "./PublicBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicBoard.vue?vue&type=script&setup=true&lang=js"

import "./PublicBoard.vue?vue&type=style&index=0&id=aa27b148&lang=scss"

const __exports__ = script;

export default __exports__